import { __assign, __read } from 'tslib';
import { useMachine } from '@xstate/react';
import { selectableStateMachine } from './stateMachine/stateMachine.js';
import { actions } from './stateMachine/actionsMultiple.js';
import { actions as actions$1 } from './stateMachine/actionsSelectActive.js';

var useSelectableStateMachine = function (props) {
    var _a = props.multiple, multiple = _a === void 0 ? false : _a, onSelect = props.onSelect, options = props.options, selectId = props.selectId, _b = props.selectActive, selectActive = _b === void 0 ? false : _b, triggerRef = props.triggerRef;
    var selectedOptions = options.filter(function (option) { return option.selected; });
    var isMulti = selectedOptions.length > 1 || multiple;
    var actions$2 = {};
    if (isMulti) {
        actions$2 = actions;
    }
    else if (selectActive) {
        actions$2 = actions$1;
    }
    /*
      Immer's AutoFreeze prevents React from being able to update refs.
      If it turns out that we don't need access to the Dom elements from the state machine
      then we could move them out into our React context so this isn't an issue.
  
      Cannot assign to read only property 'current' of object '#<Object>'
      https://github.com/immerjs/immer/issues/545#issuecomment-590615560
  
      Immer will not - re-freeze objects, so if we shallow freeze an object containing
      our refs then Immer will not freeze our refs.
    */
    var context = {
        selectId: selectId,
        onSelect: onSelect,
        initialSelectedOptions: selectedOptions,
        multiple: isMulti,
        options: options.map(function (o) { return (__assign(__assign({}, o), { selected: !!o.selected })); }),
        refs: Object.freeze({ triggerRef: triggerRef }),
    };
    var _c = __read(useMachine(selectableStateMachine, {
        context: context,
        actions: actions$2,
    }), 2), state = _c[0], send = _c[1];
    return { state: state, send: send };
};

export { useSelectableStateMachine };
//# sourceMappingURL=useSelectableStateMachine.js.map
